import type { Editor } from '@tiptap/react'
import { useEffect, useState } from 'react'

/**
 * Hook that tracks character count from a TipTap editor instance
 */
export const useMarkdownEditorCharacterCount = (editor: Editor | null): number => {
  const [characterCount, setCharacterCount] = useState(0)

  useEffect(() => {
    if (!editor) return

    const updateCharCount = () => setCharacterCount(editor.getText().length)
    updateCharCount()

    editor.on('update', updateCharCount)

    return () => {
      editor.off('update', updateCharCount)
    }
  }, [editor])

  return characterCount
}
